import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import styled from 'styled-components';
import { WebPageBlockBackground, WebPageBlockPosition, WebPageBlockType } from '../../../../api/types';
import { type WebPageBlockInput, type WebpageFormikValue } from '../shared';

export enum WebPageBlockReordering {
    Up,
    Down,
}

type ReorderingButtonsProps = {
    index: number;
    values: WebpageFormikValue;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
};
export const ReorderingButtons = ({ index, values, setFieldValue }: ReorderingButtonsProps) => (
    <>
        {index > 0 && index < values.webPageBlock.length - 1 ? (
            <>
                <Button
                    icon={<ArrowDownOutlined />}
                    onClick={() =>
                        swapWebPageBlockPosition(values.webPageBlock, index, WebPageBlockReordering.Down, setFieldValue)
                    }
                />
                <Button
                    icon={<ArrowUpOutlined />}
                    onClick={() =>
                        swapWebPageBlockPosition(values.webPageBlock, index, WebPageBlockReordering.Up, setFieldValue)
                    }
                />
            </>
        ) : (
            <>
                {index < values.webPageBlock.length - 1 && (
                    <Button
                        icon={<ArrowDownOutlined />}
                        onClick={() =>
                            swapWebPageBlockPosition(
                                values.webPageBlock,
                                index,
                                WebPageBlockReordering.Down,
                                setFieldValue
                            )
                        }
                    />
                )}
                {index > 0 && (
                    <Button
                        icon={<ArrowUpOutlined />}
                        onClick={() =>
                            swapWebPageBlockPosition(
                                values.webPageBlock,
                                index,
                                WebPageBlockReordering.Up,
                                setFieldValue
                            )
                        }
                    />
                )}
            </>
        )}
        <Button onClick={() => blockToDelete(index, values, setFieldValue)}>
            <DeleteOutlined />
        </Button>
    </>
);

export const blockToDelete = (
    index: number,
    values: WebpageFormikValue,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
) => {
    values.webPageBlock.splice(index, 1);
    setFieldValue(`webPageBlock`, values.webPageBlock);
};

export const swapWebPageBlockPosition = (
    webPageBlock: WebPageBlockInput[],
    index: number,
    reorder: WebPageBlockReordering,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
) => {
    const tempWebPageBlock = webPageBlock;
    const tempBlock = tempWebPageBlock[index];

    if (reorder === WebPageBlockReordering.Up) {
        tempWebPageBlock[index] = tempWebPageBlock[index - 1];
        tempWebPageBlock[index - 1] = tempBlock;
    } else {
        tempWebPageBlock[index] = tempWebPageBlock[index + 1];
        tempWebPageBlock[index + 1] = tempBlock;
    }

    setFieldValue('webPageBlock', tempWebPageBlock);
};

export const getNewBlock = (value: string): WebPageBlockInput => {
    switch (value) {
        case WebPageBlockType.Custom:
            return {
                type: WebPageBlockType.Custom,
                markdownString: { defaultValue: '', overrides: [] },
                title: { defaultValue: '', overrides: [] },
            };

        case WebPageBlockType.Column:
            return {
                type: WebPageBlockType.Column,
                title: { defaultValue: '', overrides: [] },
                columns: [
                    {
                        description: { defaultValue: '', overrides: [] },
                        title: { defaultValue: '', overrides: [] },
                    },
                    {
                        description: { defaultValue: '', overrides: [] },
                        title: { defaultValue: '', overrides: [] },
                    },
                ],
            };

        case WebPageBlockType.Image:
            return {
                type: WebPageBlockType.Image,
                descriptions: [
                    {
                        title: { defaultValue: '', overrides: [] },
                        description: { defaultValue: '', overrides: [] },
                    },
                ],
                title: { defaultValue: '', overrides: [] },
                button: {
                    isActive: false,
                    text: { defaultValue: '', overrides: [] },
                    url: '',
                },
            };

        case WebPageBlockType.TextImage:
            return {
                type: WebPageBlockType.TextImage,
                backgroundType: WebPageBlockBackground.White,
                imagePosition: WebPageBlockPosition.Left,
                description: { defaultValue: '', overrides: [] },
                title: { defaultValue: '', overrides: [] },
                button: {
                    isActive: false,
                    text: { defaultValue: '', overrides: [] },
                    url: '',
                },
            };

        case WebPageBlockType.TextCarousel:
            return {
                type: WebPageBlockType.TextCarousel,
                title: { defaultValue: '', overrides: [] },
                descriptions: [
                    { defaultValue: '', overrides: [] },
                    { defaultValue: '', overrides: [] },
                ],
            };

        default:
            throw new Error('BlockType not support');
    }
};
export const StyledIcon = styled.div`
    display: flex;
    justify-content: space-evenly;
    height: 100%;
    align-items: center;
`;

export default ReorderingButtons;
